import React from 'react';
import { usePrefetchImages } from '@/hooks/usePrefetchImages';
import { Toast, ToastDescription, ToastTitle } from '@/components/ui/toast';
import { Progress } from '@/components/ui/progress';

export const ImagePrefetch: React.FC = () => {
  const {
    isActive,
    progressPercentage,
  } = usePrefetchImages();

  return (
    <Toast open={ isActive }>
      <div className="flex items-center gap-space-md w-full">
        <div className="grid w-full">
          <ToastTitle>Fetching images</ToastTitle>
          <ToastDescription className="w-full">
            <Progress
              value={ progressPercentage }
              indeterminate={ progressPercentage < 1 }
              className="h-2 w-full mt-space-4xs"
            />
          </ToastDescription>
        </div>
      </div>
    </Toast>
  );
};
